import escapeHtml from 'escape-html'
import { Text } from 'slate'

const serialize = node => {
    if (Text.isText(node)) {

        let string = escapeHtml(node.text)

        if (node.bold) {
            string = `<strong>${string}</strong>`
        }
        
        return string
    }

    const children = node.children.map(n => serialize(n)).join('')

    switch (node.type) {
        case 'h5':
            return `<h5>${children}</h5>`
        case 'ol':
            return `<ol>${children}</ol>`
        case 'ul':
            return `<ul>${children}</ul>`
        case 'li':
            return `<li>${children}</li>`
        case 'link':
            return `<a href="${escapeHtml(node.url)}">${children}</a>`
        default:
            return `<p>${children}</p>`
    }
}


/////////////////


// const serialize = nodes => {

//     switch (nodes[0].type) {
//         case 'h5':
//             return <h5>{nodes[0].children[0].text}</h5>
//         case 'ol':
//             return `<blockquote><p>${nodes[0].children}</p></blockquote>`
//         // case 'paragraph':
//         //     return `<p>${nodes[0].children}</p>`
//         // case 'link':
//         //     return `<a href="${escapeHtml(node.url)}">${node.children}</a>`
//         // default:
//         //     return nodes[0].children
//     }

// }

export default serialize;